import styled from 'styled-components';

import { InputCheck } from '@speeki/global-ui-components';

export const PasswordCheck = styled(InputCheck)`
    margin-top: 4px;
`;
